<ng-container  *ngIf="formAvailabilityMessage && !isGovernmentFillableOnly && !hasFillableForm; else checkGovernmentFillable">
<div class="form-availability-container">
  <div class="center-container">
    <div class="wrapper">
      <img src="https://orbitaxservices.com/orbitax-assets/images/elite-form-preview.png"
           alt="Form Availability"
           width="200">
    </div>
    <h3>{{formAvailabilityMessageTitle}}</h3>
    <div class="form-availability-text" [innerHTML]="formAvailabilityMessage"></div>
  </div>
</div>
</ng-container>

<ng-template #checkGovernmentFillable>
  <ng-container *ngIf="isGovernmentFillableOnly; else checkFillableForm">
    <div class="external-filing-instructions">
      <div class="external-filing-instructions-contents">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="73" viewBox="0 0 80 73" fill="none">
          <g clip-path="url(#clip0_1548_362)">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M45.283 73C36.1356 72.9998 27.3581 69.3991 20.8586 62.9807C14.3592 56.5622 10.6632 47.8449 10.5743 38.7239L25.3668 42.6772C26.1833 46.5878 28.1307 50.1744 30.9684 52.9938C33.8062 55.8132 37.41 57.742 41.3347 58.542C45.2594 59.342 49.3332 58.9781 53.0529 57.4953C56.7725 56.0125 59.9752 53.4757 62.2652 50.1982C64.5552 46.9208 65.8324 43.0462 65.9389 39.0531C66.0454 35.06 64.9766 31.1232 62.8645 27.729C60.7524 24.3348 57.6895 21.6318 54.0541 19.9539C50.4187 18.2761 46.3701 17.6968 42.4083 18.2876L34.9094 5.33427C39.6824 3.84922 44.7207 3.40971 49.6797 4.04583C54.6387 4.68195 59.4015 6.37867 63.6421 9.01993C67.8827 11.6612 71.5012 15.1847 74.25 19.3493C76.9988 23.514 78.813 28.2216 79.5686 33.15C80.3241 38.0785 80.0032 43.1116 78.6277 47.9049C77.2523 52.6983 74.8548 57.1388 71.5991 60.9228C68.3435 64.7068 64.3067 67.7449 59.7647 69.8293C55.2228 71.9137 50.2829 72.9953 45.283 73ZM45.6604 38.0052L44.5079 37.7831L0.760742 27.9492L20.4589 20.0825L21.237 0.0090332L45.1321 37.1457L45.6604 38.0052Z"
                  fill="#F1F3F7"/>
          </g>
          <defs>
            <clipPath id="clip0_1548_362">
              <rect width="80" height="73" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <h3>Forms Announced</h3>
        <p>
          The relevant tax authority has recently <strong>announced/released</strong> the applicable form(s).
          At this time, the form(s) appear to be <strong>available only through an authenticated taxpayer login</strong>
          on the authority’s online tax portal and are not publicly accessible.
        </p>

        <p>
          Orbitax is actively working to <strong>obtain authorized access and/or an official copy</strong>
          of the form(s). This section will be <strong>updated as additional information becomes available</strong>.
        </p>

        <p>
          Please note that form availability may depend on the tax authority’s access restrictions
          and publication practices and may change without notice.
        </p>
        <p class="second-para">For details on how to populate and submit this form via the taxing
          authority, please open the <a class="pointer" (click)="openFormInstructions(); $event.preventDefault()">Form
            Instructions</a>.</p>
        <button mat-button (click)="openFormInstructions()">
          Form Instructions <i class="fa-regular fa-arrow-up-right-from-square"></i>
        </button>
      </div>
    </div>

  </ng-container>

  <ng-template #checkFillableForm>
    <ng-container *ngIf="hasFillableForm; else fillableForm">
      <app-elite-form-response-container
        [eliteFormId]="eliteFormId"
        [itemId]="itemId"
        (formValueChange)="onFormValueChange($event)">
      </app-elite-form-response-container>
    </ng-container>
  </ng-template>

  <ng-template #fillableForm>
    <div class="elite-form-empty-content">
      <div class="wrapper">
        <img src="https://orbitaxservices.com/orbitax-assets/images/elite-form-preview.png"
             alt="No Filing Items Selected"
             width="200">
        <h3>Form Preview Available</h3>
        <div class="text">
          This form has been released by the taxing authority and is available to preview.
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
